import axios from "axios";
import Config from "../../../config/index";
import {
  GET_WO_PROCESS_LOG_REPORT_FAILURE,
  GET_WO_PROCESS_LOG_REPORT_REQUEST,
  GET_WO_PROCESS_LOG_REPORT_SUCCESS,
} from "./woProcessLogTypes";

let baseUrl = Config.baseUrl;

const getWoProcessLogReportRequest = () => {
  return {
    type: GET_WO_PROCESS_LOG_REPORT_REQUEST,
  };
};

const getWoProcessLogReportSuccess = (payload) => {
  return {
    type: GET_WO_PROCESS_LOG_REPORT_SUCCESS,
    payload: payload,
  };
};

const getWoProcessLogReportFailure = (error) => {
  return {
    type: GET_WO_PROCESS_LOG_REPORT_FAILURE,
    payload: error,
  };
};

const getWoProcessLogReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWoProcessLogReportRequest());

    let url = `${baseUrl}/po/report?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWoProcessLogReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWoProcessLogReportFailure(err.message));
      });
  };
};

export { getWoProcessLogReport };
